import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  api_url = `${protocol}//${hostname}/api`
}

const getWavierCompliantRequested = () => ({
  type: types.GET_WAVIER_COMPLIANT_REQUESTED,
  payload: null
})

const getWavierCompliantFufilled = (data: any) => ({
  type: types.GET_WAVIER_COMPLIANT_FULFILLED,
  payload: data
})

const getWavierCompliantRejected = (error: any) => ({
  type: types.GET_WAVIER_COMPLIANT_REJECTED,
  payload: error
})

export const getWavierCompliant = (token: string) => {
  return (dispatch: any) => {
    dispatch(getWavierCompliantRequested())
    request
      .get(`${api_url}/wavierCompliant`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getWavierCompliantFufilled(response.body))
      })
      .catch((error) => {
        dispatch(getWavierCompliantRejected(error))
      })
  }
}